import React from 'react'
const NotificationCenterContext = React.createContext(null)
export default NotificationCenterContext